import React from 'react';

import { permissionCheck } from '../../helpers/permissionCheck';

interface Props {
    role?: string,
    requiredFlag?: string,
    children: React.ReactNode,
};

export const ComponentPermissionGateway: React.FC<Props> = ({ role, requiredFlag, children }) => {
    if (role && permissionCheck(role)) {
        return (
            <>
                {children}
            </>
        )
    }
    
    if (requiredFlag && permissionCheck(requiredFlag)) {
        return (
            <>
                {children}
            </>
        )
    }

    return (<></>)
};